<template>
  <a-alert  :message="message" :type="type" show-icon v-if="show"/>
</template>
<script>
  export default {
    name: 'JAlert',
    inject: ["closeCurrent"],
    components: {},
    props: {

    },
    data() {
      return {
        show:false,
        type:"success",
        message:"",
        timout:1000
      }
    }, methods: {
        successMsg(message,timout){
          this.show = true;
          this.type="success";
          this.message=message
          this.timout = timout
        },errorMsg(message,timout){
        this.show = true;
        this.type="error";
        this.message=message
        this.timout = timout
      }
    },watch:{
      show(){
        if(this.show){
          var that = this;
          setTimeout(()=>{
            that.show = false;
          },that.timout);
        }
      }
    }
  }
</script>
<style scoped>
  .ant-alert{
    height: 40px;
  }
</style>